import { render, staticRenderFns } from "./OeffnungLabel.vue?vue&type=template&id=32b9242e"
import script from "./OeffnungLabel.vue?vue&type=script&lang=ts"
export * from "./OeffnungLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports